import { StationFleetRow } from './station-fleet-row'
import { StationSpotlightCard } from './station-spotlight-card'
import type { FleetVehicle } from '@/lib/api/fleet-api'
import { useFleetSpotlight } from '@/hooks/use-fleet-spotlight'
import { isFleetOffline } from '@/lib/fleet-format'
import { m } from '@/lib/paraglide/messages'

interface Props {
    vehicles: FleetVehicle[]
    isFetching: boolean
}

// Cột phải màn máy trạm: spotlight xe vừa khởi hành + danh sách xe đang chạy.
export function StationFleetPanel({ vehicles, isFetching }: Props) {
    const { moving, spotlight, pinnedId, departedIds, togglePin } =
        useFleetSpotlight(vehicles)

    const stopped = vehicles.filter(
        (v) => !isFleetOffline(v) && v.gps?.motion_status === 1,
    ).length
    const offline = vehicles.filter((v) => isFleetOffline(v)).length
    // Danh sách hiển thị toàn bộ xe (xe đang chạy lên trước), trừ xe đang
    // spotlight. Logic xoay spotlight mới phụ thuộc có/không xe chạy, nhưng danh
    // sách thì luôn liệt kê hết để không xe nào biến mất khỏi màn hình.
    const movingIds = new Set(moving.map((v) => v.vehicle_id))
    const others = [
        ...moving,
        ...vehicles.filter((v) => !movingIds.has(v.vehicle_id)),
    ].filter((v) => v.vehicle_id !== spotlight?.vehicle_id)

    return (
        <div className="station-fleet">
            <div className="station-fleet-head">
                <span className="station-fleet-title">
                    {m.station_fleet_title()}
                </span>
                <span className="station-fleet-count">
                    <span
                        className={`led ${moving.length ? 'led-live' : 'led-off'}`}
                    />
                    {m.station_fleet_moving_count({ count: moving.length })}
                </span>
                {isFetching && (
                    <span className="station-fleet-sync" aria-hidden="true" />
                )}
            </div>

            {spotlight ? (
                <div className="station-fleet-scroll">
                    <StationSpotlightCard
                        vehicle={spotlight}
                        pinned={pinnedId === spotlight.vehicle_id}
                        onTogglePin={togglePin}
                    />
                    {others.length > 0 && (
                        <div className="station-fleet-list">
                            {others.map((v) => (
                                <StationFleetRow
                                    key={v.vehicle_id}
                                    vehicle={v}
                                    active={false}
                                    departed={departedIds.has(v.vehicle_id)}
                                    onSelect={togglePin}
                                />
                            ))}
                        </div>
                    )}
                </div>
            ) : (
                <div className="station-fleet-empty">
                    {m.station_fleet_empty()}
                </div>
            )}

            <div className="station-fleet-foot">
                {m.station_fleet_stopped_count({ stopped, offline })}
            </div>
        </div>
    )
}
